export default __webpack_public_path__ + "static/media/demo_feedback_loop.f6685880.gif";